import { Link } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";

export default function NotFound() {
  return (
    <MarketingLayout>
      <section className="max-w-xl mx-auto px-6 py-32 text-center">
        <div className="font-display font-black text-5xl text-brand">404</div>
        <h1 className="font-display font-black type-title mt-4 tracking-tighter">PAGE NOT FOUND</h1>
        <p className="text-ink-muted mt-4 mb-8">This route doesn&apos;t exist — but your demo video can.</p>
        <Link to="/" className="brutal-btn">Back home</Link>
      </section>
    </MarketingLayout>
  );
}
